import type { VoiceData, SectionStatus } from '../../types/canvas';
import { ActionBar } from './ActionBar';

interface VoiceCardProps {
  data: VoiceData;
  status: SectionStatus;
  onApprove?: () => void;
  onRefine?: () => void;
  onAnother?: () => void;
  refineDisabled?: boolean;
}

export function VoiceCard({ data, status, onApprove, onRefine, onAnother, refineDisabled }: VoiceCardProps) {
  return (
    <div className="bg-surface border border-border rounded-lg p-6 sm:px-7 relative">
      <span className="absolute top-3 left-4 font-display text-5xl text-border leading-none select-none" aria-hidden="true">
        &ldquo;
      </span>
      <div className="pl-6">
        <span className="block text-[10px] font-semibold tracking-wider uppercase text-placeholder mb-2">
          Voice
        </span>
        <p className="font-display text-base italic text-foreground leading-relaxed [font-variation-settings:'opsz'_48,'SOFT'_80]">
          {data.prose}
        </p>
      </div>
      <ActionBar status={status} onApprove={onApprove} onRefine={onRefine} onAnother={onAnother} refineDisabled={refineDisabled} />
    </div>
  );
}
